import { createReducer, on } from '@ngrx/store';

import * as fromChartActions from '../actions/chart.actions';

export const chartFeatureKey = 'chart';

export interface State {
  colors: string[];
}

export const initialState: State = {
  colors: []
};

export const reducer = createReducer(
  initialState,
  on(fromChartActions.updateChartColors, (state, { payload }) => ({
    ...state,
    colors: payload.colors
  }))
);
